/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as MainRouteImport } from './routes/_main'
import { Route as AuthAnonymousRouteImport } from './routes/_auth/_anonymous'
import { Route as AuthMobileOnlyRouteImport } from './routes/_auth/mobile-only'
import { Route as PolicyIndexRouteImport } from './routes/policy/index'
import { Route as PolicySlugRouteImport } from './routes/policy/$slug'
import { Route as AuthAnonymousAcceptInviteRouteImport } from './routes/_auth/_anonymous/accept-invite'
import { Route as AuthAnonymousForgotPasswordRouteImport } from './routes/_auth/_anonymous/forgot-password'
import { Route as AuthAnonymousLoginRouteImport } from './routes/_auth/_anonymous/login'
import { Route as AuthAnonymousResetPasswordRouteImport } from './routes/_auth/_anonymous/reset-password'
import { Route as AuthAnonymousResubmitRouteImport } from './routes/_auth/_anonymous/resubmit'
import { Route as MainDashboardIndexRouteImport } from './routes/_main/dashboard/index'
import { Route as MainDashboardAttendanceRouteImport } from './routes/_main/dashboard/attendance'
import { Route as MainDashboardAuditRouteImport } from './routes/_main/dashboard/audit'
import { Route as MainDashboardNotificationsRouteImport } from './routes/_main/dashboard/notifications'
import { Route as MainDashboardReportsRouteImport } from './routes/_main/dashboard/reports'
import { Route as MainDashboardSettingsRouteImport } from './routes/_main/dashboard/settings'
import { Route as MainDashboardTrackingRouteImport } from './routes/_main/dashboard/tracking'
import { Route as MainDashboardWaitingListRouteImport } from './routes/_main/dashboard/waiting-list'
import { Route as MainDashboardBreaksIndexRouteImport } from './routes/_main/dashboard/breaks/index'
import { Route as MainDashboardBreaksIdRouteImport } from './routes/_main/dashboard/breaks/$id'
import { Route as MainDashboardCompaniesIndexRouteImport } from './routes/_main/dashboard/companies/index'
import { Route as MainDashboardCompaniesIdRouteImport } from './routes/_main/dashboard/companies/$id'
import { Route as MainDashboardCompaniesNewRouteImport } from './routes/_main/dashboard/companies/new'
import { Route as MainDashboardDeviceChangesIndexRouteImport } from './routes/_main/dashboard/device-changes/index'
import { Route as MainDashboardDeviceChangesIdRouteImport } from './routes/_main/dashboard/device-changes/$id'
import { Route as MainDashboardEmployeesIndexRouteImport } from './routes/_main/dashboard/employees/index'
import { Route as MainDashboardEmployeesIdRouteImport } from './routes/_main/dashboard/employees/$id'
import { Route as MainDashboardEmployeesNewRouteImport } from './routes/_main/dashboard/employees/new'
import { Route as MainDashboardIncidentReportTypesIndexRouteImport } from './routes/_main/dashboard/incident-report-types/index'
import { Route as MainDashboardIncidentReportTypesNewRouteImport } from './routes/_main/dashboard/incident-report-types/new'
import { Route as MainDashboardIncidentsIndexRouteImport } from './routes/_main/dashboard/incidents/index'
import { Route as MainDashboardIncidentsIdRouteImport } from './routes/_main/dashboard/incidents/$id'
import { Route as MainDashboardLeaveTypesIndexRouteImport } from './routes/_main/dashboard/leave-types/index'
import { Route as MainDashboardLeaveTypesNewRouteImport } from './routes/_main/dashboard/leave-types/new'
import { Route as MainDashboardLeaveIndexRouteImport } from './routes/_main/dashboard/leave/index'
import { Route as MainDashboardLeaveIdRouteImport } from './routes/_main/dashboard/leave/$id'
import { Route as MainDashboardMaintenanceIndexRouteImport } from './routes/_main/dashboard/maintenance/index'
import { Route as MainDashboardMaintenanceIdRouteImport } from './routes/_main/dashboard/maintenance/$id'
import { Route as MainDashboardMaintenanceNewRouteImport } from './routes/_main/dashboard/maintenance/new'
import { Route as MainDashboardPayrollAdjustmentsIndexRouteImport } from './routes/_main/dashboard/payroll-adjustments/index'
import { Route as MainDashboardPayrollRunsIndexRouteImport } from './routes/_main/dashboard/payroll-runs/index'
import { Route as MainDashboardPayrollRunsMonthRouteImport } from './routes/_main/dashboard/payroll-runs/$month'
import { Route as MainDashboardPayrollRunsItemTypesRouteImport } from './routes/_main/dashboard/payroll-runs/item-types'
import { Route as MainDashboardPayrollRunsRulesRouteImport } from './routes/_main/dashboard/payroll-runs/rules'
import { Route as MainDashboardPoliciesIndexRouteImport } from './routes/_main/dashboard/policies/index'
import { Route as MainDashboardShiftsIndexRouteImport } from './routes/_main/dashboard/shifts/index'
import { Route as MainDashboardShiftsTemplatesRouteImport } from './routes/_main/dashboard/shifts/templates'
import { Route as MainDashboardUpdatesIndexRouteImport } from './routes/_main/dashboard/updates/index'
import { Route as MainDashboardUpdatesIdRouteImport } from './routes/_main/dashboard/updates/$id'
import { Route as MainDashboardUpdatesNewRouteImport } from './routes/_main/dashboard/updates/new'
import { Route as MainDashboardZonesIndexRouteImport } from './routes/_main/dashboard/zones/index'
import { Route as MainDashboardZonesIdRouteImport } from './routes/_main/dashboard/zones/$id'
import { Route as MainDashboardZonesNewRouteImport } from './routes/_main/dashboard/zones/new'
import { Route as MainDashboardCompaniesIdEditRouteImport } from './routes/_main/dashboard/companies/$id.edit'
import { Route as MainDashboardEmployeesIdEditRouteImport } from './routes/_main/dashboard/employees/$id.edit'
import { Route as MainDashboardIncidentReportTypesIdEditRouteImport } from './routes/_main/dashboard/incident-report-types/$id.edit'
import { Route as MainDashboardLeaveTypesIdEditRouteImport } from './routes/_main/dashboard/leave-types/$id.edit'
import { Route as MainDashboardMaintenanceIdEditRouteImport } from './routes/_main/dashboard/maintenance/$id.edit'
import { Route as MainDashboardUpdatesIdEditRouteImport } from './routes/_main/dashboard/updates/$id.edit'
import { Route as MainDashboardZonesIdEditRouteImport } from './routes/_main/dashboard/zones/$id.edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const MainRoute = MainRouteImport.update({
  id: '/_main',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAnonymousRoute = AuthAnonymousRouteImport.update({
  id: '/_anonymous',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMobileOnlyRoute = AuthMobileOnlyRouteImport.update({
  id: '/mobile-only',
  path: '/mobile-only',
  getParentRoute: () => AuthRoute,
} as any)
const PolicyIndexRoute = PolicyIndexRouteImport.update({
  id: '/policy/',
  path: '/policy/',
  getParentRoute: () => rootRouteImport,
} as any)
const PolicySlugRoute = PolicySlugRouteImport.update({
  id: '/policy/$slug',
  path: '/policy/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAnonymousAcceptInviteRoute =
  AuthAnonymousAcceptInviteRouteImport.update({
    id: '/accept-invite',
    path: '/accept-invite',
    getParentRoute: () => AuthAnonymousRoute,
  } as any)
const AuthAnonymousForgotPasswordRoute =
  AuthAnonymousForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => AuthAnonymousRoute,
  } as any)
const AuthAnonymousLoginRoute = AuthAnonymousLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthAnonymousRoute,
} as any)
const AuthAnonymousResetPasswordRoute =
  AuthAnonymousResetPasswordRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => AuthAnonymousRoute,
  } as any)
const AuthAnonymousResubmitRoute = AuthAnonymousResubmitRouteImport.update({
  id: '/resubmit',
  path: '/resubmit',
  getParentRoute: () => AuthAnonymousRoute,
} as any)
const MainDashboardIndexRoute = MainDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardAttendanceRoute = MainDashboardAttendanceRouteImport.update({
  id: '/dashboard/attendance',
  path: '/dashboard/attendance',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardAuditRoute = MainDashboardAuditRouteImport.update({
  id: '/dashboard/audit',
  path: '/dashboard/audit',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardNotificationsRoute =
  MainDashboardNotificationsRouteImport.update({
    id: '/dashboard/notifications',
    path: '/dashboard/notifications',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardReportsRoute = MainDashboardReportsRouteImport.update({
  id: '/dashboard/reports',
  path: '/dashboard/reports',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardSettingsRoute = MainDashboardSettingsRouteImport.update({
  id: '/dashboard/settings',
  path: '/dashboard/settings',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardTrackingRoute = MainDashboardTrackingRouteImport.update({
  id: '/dashboard/tracking',
  path: '/dashboard/tracking',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardWaitingListRoute =
  MainDashboardWaitingListRouteImport.update({
    id: '/dashboard/waiting-list',
    path: '/dashboard/waiting-list',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardBreaksIndexRoute =
  MainDashboardBreaksIndexRouteImport.update({
    id: '/dashboard/breaks/',
    path: '/dashboard/breaks/',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardBreaksIdRoute = MainDashboardBreaksIdRouteImport.update({
  id: '/dashboard/breaks/$id',
  path: '/dashboard/breaks/$id',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardCompaniesIndexRoute =
  MainDashboardCompaniesIndexRouteImport.update({
    id: '/dashboard/companies/',
    path: '/dashboard/companies/',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardCompaniesIdRoute =
  MainDashboardCompaniesIdRouteImport.update({
    id: '/dashboard/companies/$id',
    path: '/dashboard/companies/$id',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardCompaniesNewRoute =
  MainDashboardCompaniesNewRouteImport.update({
    id: '/dashboard/companies/new',
    path: '/dashboard/companies/new',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardDeviceChangesIndexRoute =
  MainDashboardDeviceChangesIndexRouteImport.update({
    id: '/dashboard/device-changes/',
    path: '/dashboard/device-changes/',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardDeviceChangesIdRoute =
  MainDashboardDeviceChangesIdRouteImport.update({
    id: '/dashboard/device-changes/$id',
    path: '/dashboard/device-changes/$id',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardEmployeesIndexRoute =
  MainDashboardEmployeesIndexRouteImport.update({
    id: '/dashboard/employees/',
    path: '/dashboard/employees/',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardEmployeesIdRoute =
  MainDashboardEmployeesIdRouteImport.update({
    id: '/dashboard/employees/$id',
    path: '/dashboard/employees/$id',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardEmployeesNewRoute =
  MainDashboardEmployeesNewRouteImport.update({
    id: '/dashboard/employees/new',
    path: '/dashboard/employees/new',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardIncidentReportTypesIndexRoute =
  MainDashboardIncidentReportTypesIndexRouteImport.update({
    id: '/dashboard/incident-report-types/',
    path: '/dashboard/incident-report-types/',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardIncidentReportTypesNewRoute =
  MainDashboardIncidentReportTypesNewRouteImport.update({
    id: '/dashboard/incident-report-types/new',
    path: '/dashboard/incident-report-types/new',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardIncidentsIndexRoute =
  MainDashboardIncidentsIndexRouteImport.update({
    id: '/dashboard/incidents/',
    path: '/dashboard/incidents/',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardIncidentsIdRoute =
  MainDashboardIncidentsIdRouteImport.update({
    id: '/dashboard/incidents/$id',
    path: '/dashboard/incidents/$id',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardLeaveTypesIndexRoute =
  MainDashboardLeaveTypesIndexRouteImport.update({
    id: '/dashboard/leave-types/',
    path: '/dashboard/leave-types/',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardLeaveTypesNewRoute =
  MainDashboardLeaveTypesNewRouteImport.update({
    id: '/dashboard/leave-types/new',
    path: '/dashboard/leave-types/new',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardLeaveIndexRoute = MainDashboardLeaveIndexRouteImport.update({
  id: '/dashboard/leave/',
  path: '/dashboard/leave/',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardLeaveIdRoute = MainDashboardLeaveIdRouteImport.update({
  id: '/dashboard/leave/$id',
  path: '/dashboard/leave/$id',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardMaintenanceIndexRoute =
  MainDashboardMaintenanceIndexRouteImport.update({
    id: '/dashboard/maintenance/',
    path: '/dashboard/maintenance/',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardMaintenanceIdRoute =
  MainDashboardMaintenanceIdRouteImport.update({
    id: '/dashboard/maintenance/$id',
    path: '/dashboard/maintenance/$id',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardMaintenanceNewRoute =
  MainDashboardMaintenanceNewRouteImport.update({
    id: '/dashboard/maintenance/new',
    path: '/dashboard/maintenance/new',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardPayrollAdjustmentsIndexRoute =
  MainDashboardPayrollAdjustmentsIndexRouteImport.update({
    id: '/dashboard/payroll-adjustments/',
    path: '/dashboard/payroll-adjustments/',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardPayrollRunsIndexRoute =
  MainDashboardPayrollRunsIndexRouteImport.update({
    id: '/dashboard/payroll-runs/',
    path: '/dashboard/payroll-runs/',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardPayrollRunsMonthRoute =
  MainDashboardPayrollRunsMonthRouteImport.update({
    id: '/dashboard/payroll-runs/$month',
    path: '/dashboard/payroll-runs/$month',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardPayrollRunsItemTypesRoute =
  MainDashboardPayrollRunsItemTypesRouteImport.update({
    id: '/dashboard/payroll-runs/item-types',
    path: '/dashboard/payroll-runs/item-types',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardPayrollRunsRulesRoute =
  MainDashboardPayrollRunsRulesRouteImport.update({
    id: '/dashboard/payroll-runs/rules',
    path: '/dashboard/payroll-runs/rules',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardPoliciesIndexRoute =
  MainDashboardPoliciesIndexRouteImport.update({
    id: '/dashboard/policies/',
    path: '/dashboard/policies/',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardShiftsIndexRoute =
  MainDashboardShiftsIndexRouteImport.update({
    id: '/dashboard/shifts/',
    path: '/dashboard/shifts/',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardShiftsTemplatesRoute =
  MainDashboardShiftsTemplatesRouteImport.update({
    id: '/dashboard/shifts/templates',
    path: '/dashboard/shifts/templates',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardUpdatesIndexRoute =
  MainDashboardUpdatesIndexRouteImport.update({
    id: '/dashboard/updates/',
    path: '/dashboard/updates/',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardUpdatesIdRoute = MainDashboardUpdatesIdRouteImport.update({
  id: '/dashboard/updates/$id',
  path: '/dashboard/updates/$id',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardUpdatesNewRoute = MainDashboardUpdatesNewRouteImport.update({
  id: '/dashboard/updates/new',
  path: '/dashboard/updates/new',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardZonesIndexRoute = MainDashboardZonesIndexRouteImport.update({
  id: '/dashboard/zones/',
  path: '/dashboard/zones/',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardZonesIdRoute = MainDashboardZonesIdRouteImport.update({
  id: '/dashboard/zones/$id',
  path: '/dashboard/zones/$id',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardZonesNewRoute = MainDashboardZonesNewRouteImport.update({
  id: '/dashboard/zones/new',
  path: '/dashboard/zones/new',
  getParentRoute: () => MainRoute,
} as any)
const MainDashboardCompaniesIdEditRoute =
  MainDashboardCompaniesIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => MainDashboardCompaniesIdRoute,
  } as any)
const MainDashboardEmployeesIdEditRoute =
  MainDashboardEmployeesIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => MainDashboardEmployeesIdRoute,
  } as any)
const MainDashboardIncidentReportTypesIdEditRoute =
  MainDashboardIncidentReportTypesIdEditRouteImport.update({
    id: '/dashboard/incident-report-types/$id/edit',
    path: '/dashboard/incident-report-types/$id/edit',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardLeaveTypesIdEditRoute =
  MainDashboardLeaveTypesIdEditRouteImport.update({
    id: '/dashboard/leave-types/$id/edit',
    path: '/dashboard/leave-types/$id/edit',
    getParentRoute: () => MainRoute,
  } as any)
const MainDashboardMaintenanceIdEditRoute =
  MainDashboardMaintenanceIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => MainDashboardMaintenanceIdRoute,
  } as any)
const MainDashboardUpdatesIdEditRoute =
  MainDashboardUpdatesIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => MainDashboardUpdatesIdRoute,
  } as any)
const MainDashboardZonesIdEditRoute =
  MainDashboardZonesIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => MainDashboardZonesIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/mobile-only': typeof AuthMobileOnlyRoute
  '/policy/$slug': typeof PolicySlugRoute
  '/policy/': typeof PolicyIndexRoute
  '/accept-invite': typeof AuthAnonymousAcceptInviteRoute
  '/forgot-password': typeof AuthAnonymousForgotPasswordRoute
  '/login': typeof AuthAnonymousLoginRoute
  '/reset-password': typeof AuthAnonymousResetPasswordRoute
  '/resubmit': typeof AuthAnonymousResubmitRoute
  '/dashboard/attendance': typeof MainDashboardAttendanceRoute
  '/dashboard/audit': typeof MainDashboardAuditRoute
  '/dashboard/notifications': typeof MainDashboardNotificationsRoute
  '/dashboard/reports': typeof MainDashboardReportsRoute
  '/dashboard/settings': typeof MainDashboardSettingsRoute
  '/dashboard/tracking': typeof MainDashboardTrackingRoute
  '/dashboard/waiting-list': typeof MainDashboardWaitingListRoute
  '/dashboard/': typeof MainDashboardIndexRoute
  '/dashboard/breaks/$id': typeof MainDashboardBreaksIdRoute
  '/dashboard/companies/$id': typeof MainDashboardCompaniesIdRouteWithChildren
  '/dashboard/companies/new': typeof MainDashboardCompaniesNewRoute
  '/dashboard/device-changes/$id': typeof MainDashboardDeviceChangesIdRoute
  '/dashboard/employees/$id': typeof MainDashboardEmployeesIdRouteWithChildren
  '/dashboard/employees/new': typeof MainDashboardEmployeesNewRoute
  '/dashboard/incident-report-types/new': typeof MainDashboardIncidentReportTypesNewRoute
  '/dashboard/incidents/$id': typeof MainDashboardIncidentsIdRoute
  '/dashboard/leave-types/new': typeof MainDashboardLeaveTypesNewRoute
  '/dashboard/leave/$id': typeof MainDashboardLeaveIdRoute
  '/dashboard/maintenance/$id': typeof MainDashboardMaintenanceIdRouteWithChildren
  '/dashboard/maintenance/new': typeof MainDashboardMaintenanceNewRoute
  '/dashboard/payroll-runs/$month': typeof MainDashboardPayrollRunsMonthRoute
  '/dashboard/payroll-runs/item-types': typeof MainDashboardPayrollRunsItemTypesRoute
  '/dashboard/payroll-runs/rules': typeof MainDashboardPayrollRunsRulesRoute
  '/dashboard/shifts/templates': typeof MainDashboardShiftsTemplatesRoute
  '/dashboard/updates/$id': typeof MainDashboardUpdatesIdRouteWithChildren
  '/dashboard/updates/new': typeof MainDashboardUpdatesNewRoute
  '/dashboard/zones/$id': typeof MainDashboardZonesIdRouteWithChildren
  '/dashboard/zones/new': typeof MainDashboardZonesNewRoute
  '/dashboard/breaks/': typeof MainDashboardBreaksIndexRoute
  '/dashboard/companies/': typeof MainDashboardCompaniesIndexRoute
  '/dashboard/device-changes/': typeof MainDashboardDeviceChangesIndexRoute
  '/dashboard/employees/': typeof MainDashboardEmployeesIndexRoute
  '/dashboard/incident-report-types/': typeof MainDashboardIncidentReportTypesIndexRoute
  '/dashboard/incidents/': typeof MainDashboardIncidentsIndexRoute
  '/dashboard/leave-types/': typeof MainDashboardLeaveTypesIndexRoute
  '/dashboard/leave/': typeof MainDashboardLeaveIndexRoute
  '/dashboard/maintenance/': typeof MainDashboardMaintenanceIndexRoute
  '/dashboard/payroll-adjustments/': typeof MainDashboardPayrollAdjustmentsIndexRoute
  '/dashboard/payroll-runs/': typeof MainDashboardPayrollRunsIndexRoute
  '/dashboard/policies/': typeof MainDashboardPoliciesIndexRoute
  '/dashboard/shifts/': typeof MainDashboardShiftsIndexRoute
  '/dashboard/updates/': typeof MainDashboardUpdatesIndexRoute
  '/dashboard/zones/': typeof MainDashboardZonesIndexRoute
  '/dashboard/companies/$id/edit': typeof MainDashboardCompaniesIdEditRoute
  '/dashboard/employees/$id/edit': typeof MainDashboardEmployeesIdEditRoute
  '/dashboard/incident-report-types/$id/edit': typeof MainDashboardIncidentReportTypesIdEditRoute
  '/dashboard/leave-types/$id/edit': typeof MainDashboardLeaveTypesIdEditRoute
  '/dashboard/maintenance/$id/edit': typeof MainDashboardMaintenanceIdEditRoute
  '/dashboard/updates/$id/edit': typeof MainDashboardUpdatesIdEditRoute
  '/dashboard/zones/$id/edit': typeof MainDashboardZonesIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/mobile-only': typeof AuthMobileOnlyRoute
  '/policy/$slug': typeof PolicySlugRoute
  '/policy': typeof PolicyIndexRoute
  '/accept-invite': typeof AuthAnonymousAcceptInviteRoute
  '/forgot-password': typeof AuthAnonymousForgotPasswordRoute
  '/login': typeof AuthAnonymousLoginRoute
  '/reset-password': typeof AuthAnonymousResetPasswordRoute
  '/resubmit': typeof AuthAnonymousResubmitRoute
  '/dashboard/attendance': typeof MainDashboardAttendanceRoute
  '/dashboard/audit': typeof MainDashboardAuditRoute
  '/dashboard/notifications': typeof MainDashboardNotificationsRoute
  '/dashboard/reports': typeof MainDashboardReportsRoute
  '/dashboard/settings': typeof MainDashboardSettingsRoute
  '/dashboard/tracking': typeof MainDashboardTrackingRoute
  '/dashboard/waiting-list': typeof MainDashboardWaitingListRoute
  '/dashboard': typeof MainDashboardIndexRoute
  '/dashboard/breaks/$id': typeof MainDashboardBreaksIdRoute
  '/dashboard/companies/$id': typeof MainDashboardCompaniesIdRouteWithChildren
  '/dashboard/companies/new': typeof MainDashboardCompaniesNewRoute
  '/dashboard/device-changes/$id': typeof MainDashboardDeviceChangesIdRoute
  '/dashboard/employees/$id': typeof MainDashboardEmployeesIdRouteWithChildren
  '/dashboard/employees/new': typeof MainDashboardEmployeesNewRoute
  '/dashboard/incident-report-types/new': typeof MainDashboardIncidentReportTypesNewRoute
  '/dashboard/incidents/$id': typeof MainDashboardIncidentsIdRoute
  '/dashboard/leave-types/new': typeof MainDashboardLeaveTypesNewRoute
  '/dashboard/leave/$id': typeof MainDashboardLeaveIdRoute
  '/dashboard/maintenance/$id': typeof MainDashboardMaintenanceIdRouteWithChildren
  '/dashboard/maintenance/new': typeof MainDashboardMaintenanceNewRoute
  '/dashboard/payroll-runs/$month': typeof MainDashboardPayrollRunsMonthRoute
  '/dashboard/payroll-runs/item-types': typeof MainDashboardPayrollRunsItemTypesRoute
  '/dashboard/payroll-runs/rules': typeof MainDashboardPayrollRunsRulesRoute
  '/dashboard/shifts/templates': typeof MainDashboardShiftsTemplatesRoute
  '/dashboard/updates/$id': typeof MainDashboardUpdatesIdRouteWithChildren
  '/dashboard/updates/new': typeof MainDashboardUpdatesNewRoute
  '/dashboard/zones/$id': typeof MainDashboardZonesIdRouteWithChildren
  '/dashboard/zones/new': typeof MainDashboardZonesNewRoute
  '/dashboard/breaks': typeof MainDashboardBreaksIndexRoute
  '/dashboard/companies': typeof MainDashboardCompaniesIndexRoute
  '/dashboard/device-changes': typeof MainDashboardDeviceChangesIndexRoute
  '/dashboard/employees': typeof MainDashboardEmployeesIndexRoute
  '/dashboard/incident-report-types': typeof MainDashboardIncidentReportTypesIndexRoute
  '/dashboard/incidents': typeof MainDashboardIncidentsIndexRoute
  '/dashboard/leave-types': typeof MainDashboardLeaveTypesIndexRoute
  '/dashboard/leave': typeof MainDashboardLeaveIndexRoute
  '/dashboard/maintenance': typeof MainDashboardMaintenanceIndexRoute
  '/dashboard/payroll-adjustments': typeof MainDashboardPayrollAdjustmentsIndexRoute
  '/dashboard/payroll-runs': typeof MainDashboardPayrollRunsIndexRoute
  '/dashboard/policies': typeof MainDashboardPoliciesIndexRoute
  '/dashboard/shifts': typeof MainDashboardShiftsIndexRoute
  '/dashboard/updates': typeof MainDashboardUpdatesIndexRoute
  '/dashboard/zones': typeof MainDashboardZonesIndexRoute
  '/dashboard/companies/$id/edit': typeof MainDashboardCompaniesIdEditRoute
  '/dashboard/employees/$id/edit': typeof MainDashboardEmployeesIdEditRoute
  '/dashboard/incident-report-types/$id/edit': typeof MainDashboardIncidentReportTypesIdEditRoute
  '/dashboard/leave-types/$id/edit': typeof MainDashboardLeaveTypesIdEditRoute
  '/dashboard/maintenance/$id/edit': typeof MainDashboardMaintenanceIdEditRoute
  '/dashboard/updates/$id/edit': typeof MainDashboardUpdatesIdEditRoute
  '/dashboard/zones/$id/edit': typeof MainDashboardZonesIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_main': typeof MainRouteWithChildren
  '/_auth/_anonymous': typeof AuthAnonymousRouteWithChildren
  '/_auth/mobile-only': typeof AuthMobileOnlyRoute
  '/policy/$slug': typeof PolicySlugRoute
  '/policy/': typeof PolicyIndexRoute
  '/_auth/_anonymous/accept-invite': typeof AuthAnonymousAcceptInviteRoute
  '/_auth/_anonymous/forgot-password': typeof AuthAnonymousForgotPasswordRoute
  '/_auth/_anonymous/login': typeof AuthAnonymousLoginRoute
  '/_auth/_anonymous/reset-password': typeof AuthAnonymousResetPasswordRoute
  '/_auth/_anonymous/resubmit': typeof AuthAnonymousResubmitRoute
  '/_main/dashboard/attendance': typeof MainDashboardAttendanceRoute
  '/_main/dashboard/audit': typeof MainDashboardAuditRoute
  '/_main/dashboard/notifications': typeof MainDashboardNotificationsRoute
  '/_main/dashboard/reports': typeof MainDashboardReportsRoute
  '/_main/dashboard/settings': typeof MainDashboardSettingsRoute
  '/_main/dashboard/tracking': typeof MainDashboardTrackingRoute
  '/_main/dashboard/waiting-list': typeof MainDashboardWaitingListRoute
  '/_main/dashboard/': typeof MainDashboardIndexRoute
  '/_main/dashboard/breaks/$id': typeof MainDashboardBreaksIdRoute
  '/_main/dashboard/companies/$id': typeof MainDashboardCompaniesIdRouteWithChildren
  '/_main/dashboard/companies/new': typeof MainDashboardCompaniesNewRoute
  '/_main/dashboard/device-changes/$id': typeof MainDashboardDeviceChangesIdRoute
  '/_main/dashboard/employees/$id': typeof MainDashboardEmployeesIdRouteWithChildren
  '/_main/dashboard/employees/new': typeof MainDashboardEmployeesNewRoute
  '/_main/dashboard/incident-report-types/new': typeof MainDashboardIncidentReportTypesNewRoute
  '/_main/dashboard/incidents/$id': typeof MainDashboardIncidentsIdRoute
  '/_main/dashboard/leave-types/new': typeof MainDashboardLeaveTypesNewRoute
  '/_main/dashboard/leave/$id': typeof MainDashboardLeaveIdRoute
  '/_main/dashboard/maintenance/$id': typeof MainDashboardMaintenanceIdRouteWithChildren
  '/_main/dashboard/maintenance/new': typeof MainDashboardMaintenanceNewRoute
  '/_main/dashboard/payroll-runs/$month': typeof MainDashboardPayrollRunsMonthRoute
  '/_main/dashboard/payroll-runs/item-types': typeof MainDashboardPayrollRunsItemTypesRoute
  '/_main/dashboard/payroll-runs/rules': typeof MainDashboardPayrollRunsRulesRoute
  '/_main/dashboard/shifts/templates': typeof MainDashboardShiftsTemplatesRoute
  '/_main/dashboard/updates/$id': typeof MainDashboardUpdatesIdRouteWithChildren
  '/_main/dashboard/updates/new': typeof MainDashboardUpdatesNewRoute
  '/_main/dashboard/zones/$id': typeof MainDashboardZonesIdRouteWithChildren
  '/_main/dashboard/zones/new': typeof MainDashboardZonesNewRoute
  '/_main/dashboard/breaks/': typeof MainDashboardBreaksIndexRoute
  '/_main/dashboard/companies/': typeof MainDashboardCompaniesIndexRoute
  '/_main/dashboard/device-changes/': typeof MainDashboardDeviceChangesIndexRoute
  '/_main/dashboard/employees/': typeof MainDashboardEmployeesIndexRoute
  '/_main/dashboard/incident-report-types/': typeof MainDashboardIncidentReportTypesIndexRoute
  '/_main/dashboard/incidents/': typeof MainDashboardIncidentsIndexRoute
  '/_main/dashboard/leave-types/': typeof MainDashboardLeaveTypesIndexRoute
  '/_main/dashboard/leave/': typeof MainDashboardLeaveIndexRoute
  '/_main/dashboard/maintenance/': typeof MainDashboardMaintenanceIndexRoute
  '/_main/dashboard/payroll-adjustments/': typeof MainDashboardPayrollAdjustmentsIndexRoute
  '/_main/dashboard/payroll-runs/': typeof MainDashboardPayrollRunsIndexRoute
  '/_main/dashboard/policies/': typeof MainDashboardPoliciesIndexRoute
  '/_main/dashboard/shifts/': typeof MainDashboardShiftsIndexRoute
  '/_main/dashboard/updates/': typeof MainDashboardUpdatesIndexRoute
  '/_main/dashboard/zones/': typeof MainDashboardZonesIndexRoute
  '/_main/dashboard/companies/$id/edit': typeof MainDashboardCompaniesIdEditRoute
  '/_main/dashboard/employees/$id/edit': typeof MainDashboardEmployeesIdEditRoute
  '/_main/dashboard/incident-report-types/$id/edit': typeof MainDashboardIncidentReportTypesIdEditRoute
  '/_main/dashboard/leave-types/$id/edit': typeof MainDashboardLeaveTypesIdEditRoute
  '/_main/dashboard/maintenance/$id/edit': typeof MainDashboardMaintenanceIdEditRoute
  '/_main/dashboard/updates/$id/edit': typeof MainDashboardUpdatesIdEditRoute
  '/_main/dashboard/zones/$id/edit': typeof MainDashboardZonesIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/mobile-only'
    | '/policy/$slug'
    | '/policy/'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/resubmit'
    | '/dashboard/attendance'
    | '/dashboard/audit'
    | '/dashboard/notifications'
    | '/dashboard/reports'
    | '/dashboard/settings'
    | '/dashboard/tracking'
    | '/dashboard/waiting-list'
    | '/dashboard/'
    | '/dashboard/breaks/$id'
    | '/dashboard/companies/$id'
    | '/dashboard/companies/new'
    | '/dashboard/device-changes/$id'
    | '/dashboard/employees/$id'
    | '/dashboard/employees/new'
    | '/dashboard/incident-report-types/new'
    | '/dashboard/incidents/$id'
    | '/dashboard/leave-types/new'
    | '/dashboard/leave/$id'
    | '/dashboard/maintenance/$id'
    | '/dashboard/maintenance/new'
    | '/dashboard/payroll-runs/$month'
    | '/dashboard/payroll-runs/item-types'
    | '/dashboard/payroll-runs/rules'
    | '/dashboard/shifts/templates'
    | '/dashboard/updates/$id'
    | '/dashboard/updates/new'
    | '/dashboard/zones/$id'
    | '/dashboard/zones/new'
    | '/dashboard/breaks/'
    | '/dashboard/companies/'
    | '/dashboard/device-changes/'
    | '/dashboard/employees/'
    | '/dashboard/incident-report-types/'
    | '/dashboard/incidents/'
    | '/dashboard/leave-types/'
    | '/dashboard/leave/'
    | '/dashboard/maintenance/'
    | '/dashboard/payroll-adjustments/'
    | '/dashboard/payroll-runs/'
    | '/dashboard/policies/'
    | '/dashboard/shifts/'
    | '/dashboard/updates/'
    | '/dashboard/zones/'
    | '/dashboard/companies/$id/edit'
    | '/dashboard/employees/$id/edit'
    | '/dashboard/incident-report-types/$id/edit'
    | '/dashboard/leave-types/$id/edit'
    | '/dashboard/maintenance/$id/edit'
    | '/dashboard/updates/$id/edit'
    | '/dashboard/zones/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/mobile-only'
    | '/policy/$slug'
    | '/policy'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/resubmit'
    | '/dashboard/attendance'
    | '/dashboard/audit'
    | '/dashboard/notifications'
    | '/dashboard/reports'
    | '/dashboard/settings'
    | '/dashboard/tracking'
    | '/dashboard/waiting-list'
    | '/dashboard'
    | '/dashboard/breaks/$id'
    | '/dashboard/companies/$id'
    | '/dashboard/companies/new'
    | '/dashboard/device-changes/$id'
    | '/dashboard/employees/$id'
    | '/dashboard/employees/new'
    | '/dashboard/incident-report-types/new'
    | '/dashboard/incidents/$id'
    | '/dashboard/leave-types/new'
    | '/dashboard/leave/$id'
    | '/dashboard/maintenance/$id'
    | '/dashboard/maintenance/new'
    | '/dashboard/payroll-runs/$month'
    | '/dashboard/payroll-runs/item-types'
    | '/dashboard/payroll-runs/rules'
    | '/dashboard/shifts/templates'
    | '/dashboard/updates/$id'
    | '/dashboard/updates/new'
    | '/dashboard/zones/$id'
    | '/dashboard/zones/new'
    | '/dashboard/breaks'
    | '/dashboard/companies'
    | '/dashboard/device-changes'
    | '/dashboard/employees'
    | '/dashboard/incident-report-types'
    | '/dashboard/incidents'
    | '/dashboard/leave-types'
    | '/dashboard/leave'
    | '/dashboard/maintenance'
    | '/dashboard/payroll-adjustments'
    | '/dashboard/payroll-runs'
    | '/dashboard/policies'
    | '/dashboard/shifts'
    | '/dashboard/updates'
    | '/dashboard/zones'
    | '/dashboard/companies/$id/edit'
    | '/dashboard/employees/$id/edit'
    | '/dashboard/incident-report-types/$id/edit'
    | '/dashboard/leave-types/$id/edit'
    | '/dashboard/maintenance/$id/edit'
    | '/dashboard/updates/$id/edit'
    | '/dashboard/zones/$id/edit'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_main'
    | '/_auth/_anonymous'
    | '/_auth/mobile-only'
    | '/policy/$slug'
    | '/policy/'
    | '/_auth/_anonymous/accept-invite'
    | '/_auth/_anonymous/forgot-password'
    | '/_auth/_anonymous/login'
    | '/_auth/_anonymous/reset-password'
    | '/_auth/_anonymous/resubmit'
    | '/_main/dashboard/attendance'
    | '/_main/dashboard/audit'
    | '/_main/dashboard/notifications'
    | '/_main/dashboard/reports'
    | '/_main/dashboard/settings'
    | '/_main/dashboard/tracking'
    | '/_main/dashboard/waiting-list'
    | '/_main/dashboard/'
    | '/_main/dashboard/breaks/$id'
    | '/_main/dashboard/companies/$id'
    | '/_main/dashboard/companies/new'
    | '/_main/dashboard/device-changes/$id'
    | '/_main/dashboard/employees/$id'
    | '/_main/dashboard/employees/new'
    | '/_main/dashboard/incident-report-types/new'
    | '/_main/dashboard/incidents/$id'
    | '/_main/dashboard/leave-types/new'
    | '/_main/dashboard/leave/$id'
    | '/_main/dashboard/maintenance/$id'
    | '/_main/dashboard/maintenance/new'
    | '/_main/dashboard/payroll-runs/$month'
    | '/_main/dashboard/payroll-runs/item-types'
    | '/_main/dashboard/payroll-runs/rules'
    | '/_main/dashboard/shifts/templates'
    | '/_main/dashboard/updates/$id'
    | '/_main/dashboard/updates/new'
    | '/_main/dashboard/zones/$id'
    | '/_main/dashboard/zones/new'
    | '/_main/dashboard/breaks/'
    | '/_main/dashboard/companies/'
    | '/_main/dashboard/device-changes/'
    | '/_main/dashboard/employees/'
    | '/_main/dashboard/incident-report-types/'
    | '/_main/dashboard/incidents/'
    | '/_main/dashboard/leave-types/'
    | '/_main/dashboard/leave/'
    | '/_main/dashboard/maintenance/'
    | '/_main/dashboard/payroll-adjustments/'
    | '/_main/dashboard/payroll-runs/'
    | '/_main/dashboard/policies/'
    | '/_main/dashboard/shifts/'
    | '/_main/dashboard/updates/'
    | '/_main/dashboard/zones/'
    | '/_main/dashboard/companies/$id/edit'
    | '/_main/dashboard/employees/$id/edit'
    | '/_main/dashboard/incident-report-types/$id/edit'
    | '/_main/dashboard/leave-types/$id/edit'
    | '/_main/dashboard/maintenance/$id/edit'
    | '/_main/dashboard/updates/$id/edit'
    | '/_main/dashboard/zones/$id/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  MainRoute: typeof MainRouteWithChildren
  PolicySlugRoute: typeof PolicySlugRoute
  PolicyIndexRoute: typeof PolicyIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main': {
      id: '/_main'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MainRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_anonymous': {
      id: '/_auth/_anonymous'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthAnonymousRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/mobile-only': {
      id: '/_auth/mobile-only'
      path: '/mobile-only'
      fullPath: '/mobile-only'
      preLoaderRoute: typeof AuthMobileOnlyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/policy/': {
      id: '/policy/'
      path: '/policy'
      fullPath: '/policy/'
      preLoaderRoute: typeof PolicyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/policy/$slug': {
      id: '/policy/$slug'
      path: '/policy/$slug'
      fullPath: '/policy/$slug'
      preLoaderRoute: typeof PolicySlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_anonymous/accept-invite': {
      id: '/_auth/_anonymous/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AuthAnonymousAcceptInviteRouteImport
      parentRoute: typeof AuthAnonymousRoute
    }
    '/_auth/_anonymous/forgot-password': {
      id: '/_auth/_anonymous/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthAnonymousForgotPasswordRouteImport
      parentRoute: typeof AuthAnonymousRoute
    }
    '/_auth/_anonymous/login': {
      id: '/_auth/_anonymous/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthAnonymousLoginRouteImport
      parentRoute: typeof AuthAnonymousRoute
    }
    '/_auth/_anonymous/reset-password': {
      id: '/_auth/_anonymous/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthAnonymousResetPasswordRouteImport
      parentRoute: typeof AuthAnonymousRoute
    }
    '/_auth/_anonymous/resubmit': {
      id: '/_auth/_anonymous/resubmit'
      path: '/resubmit'
      fullPath: '/resubmit'
      preLoaderRoute: typeof AuthAnonymousResubmitRouteImport
      parentRoute: typeof AuthAnonymousRoute
    }
    '/_main/dashboard/': {
      id: '/_main/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof MainDashboardIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/attendance': {
      id: '/_main/dashboard/attendance'
      path: '/dashboard/attendance'
      fullPath: '/dashboard/attendance'
      preLoaderRoute: typeof MainDashboardAttendanceRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/audit': {
      id: '/_main/dashboard/audit'
      path: '/dashboard/audit'
      fullPath: '/dashboard/audit'
      preLoaderRoute: typeof MainDashboardAuditRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/notifications': {
      id: '/_main/dashboard/notifications'
      path: '/dashboard/notifications'
      fullPath: '/dashboard/notifications'
      preLoaderRoute: typeof MainDashboardNotificationsRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/reports': {
      id: '/_main/dashboard/reports'
      path: '/dashboard/reports'
      fullPath: '/dashboard/reports'
      preLoaderRoute: typeof MainDashboardReportsRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/settings': {
      id: '/_main/dashboard/settings'
      path: '/dashboard/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof MainDashboardSettingsRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/tracking': {
      id: '/_main/dashboard/tracking'
      path: '/dashboard/tracking'
      fullPath: '/dashboard/tracking'
      preLoaderRoute: typeof MainDashboardTrackingRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/waiting-list': {
      id: '/_main/dashboard/waiting-list'
      path: '/dashboard/waiting-list'
      fullPath: '/dashboard/waiting-list'
      preLoaderRoute: typeof MainDashboardWaitingListRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/breaks/': {
      id: '/_main/dashboard/breaks/'
      path: '/dashboard/breaks'
      fullPath: '/dashboard/breaks/'
      preLoaderRoute: typeof MainDashboardBreaksIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/breaks/$id': {
      id: '/_main/dashboard/breaks/$id'
      path: '/dashboard/breaks/$id'
      fullPath: '/dashboard/breaks/$id'
      preLoaderRoute: typeof MainDashboardBreaksIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/companies/': {
      id: '/_main/dashboard/companies/'
      path: '/dashboard/companies'
      fullPath: '/dashboard/companies/'
      preLoaderRoute: typeof MainDashboardCompaniesIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/companies/$id': {
      id: '/_main/dashboard/companies/$id'
      path: '/dashboard/companies/$id'
      fullPath: '/dashboard/companies/$id'
      preLoaderRoute: typeof MainDashboardCompaniesIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/companies/new': {
      id: '/_main/dashboard/companies/new'
      path: '/dashboard/companies/new'
      fullPath: '/dashboard/companies/new'
      preLoaderRoute: typeof MainDashboardCompaniesNewRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/device-changes/': {
      id: '/_main/dashboard/device-changes/'
      path: '/dashboard/device-changes'
      fullPath: '/dashboard/device-changes/'
      preLoaderRoute: typeof MainDashboardDeviceChangesIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/device-changes/$id': {
      id: '/_main/dashboard/device-changes/$id'
      path: '/dashboard/device-changes/$id'
      fullPath: '/dashboard/device-changes/$id'
      preLoaderRoute: typeof MainDashboardDeviceChangesIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/employees/': {
      id: '/_main/dashboard/employees/'
      path: '/dashboard/employees'
      fullPath: '/dashboard/employees/'
      preLoaderRoute: typeof MainDashboardEmployeesIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/employees/$id': {
      id: '/_main/dashboard/employees/$id'
      path: '/dashboard/employees/$id'
      fullPath: '/dashboard/employees/$id'
      preLoaderRoute: typeof MainDashboardEmployeesIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/employees/new': {
      id: '/_main/dashboard/employees/new'
      path: '/dashboard/employees/new'
      fullPath: '/dashboard/employees/new'
      preLoaderRoute: typeof MainDashboardEmployeesNewRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/incident-report-types/': {
      id: '/_main/dashboard/incident-report-types/'
      path: '/dashboard/incident-report-types'
      fullPath: '/dashboard/incident-report-types/'
      preLoaderRoute: typeof MainDashboardIncidentReportTypesIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/incident-report-types/new': {
      id: '/_main/dashboard/incident-report-types/new'
      path: '/dashboard/incident-report-types/new'
      fullPath: '/dashboard/incident-report-types/new'
      preLoaderRoute: typeof MainDashboardIncidentReportTypesNewRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/incidents/': {
      id: '/_main/dashboard/incidents/'
      path: '/dashboard/incidents'
      fullPath: '/dashboard/incidents/'
      preLoaderRoute: typeof MainDashboardIncidentsIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/incidents/$id': {
      id: '/_main/dashboard/incidents/$id'
      path: '/dashboard/incidents/$id'
      fullPath: '/dashboard/incidents/$id'
      preLoaderRoute: typeof MainDashboardIncidentsIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/leave-types/': {
      id: '/_main/dashboard/leave-types/'
      path: '/dashboard/leave-types'
      fullPath: '/dashboard/leave-types/'
      preLoaderRoute: typeof MainDashboardLeaveTypesIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/leave-types/new': {
      id: '/_main/dashboard/leave-types/new'
      path: '/dashboard/leave-types/new'
      fullPath: '/dashboard/leave-types/new'
      preLoaderRoute: typeof MainDashboardLeaveTypesNewRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/leave/': {
      id: '/_main/dashboard/leave/'
      path: '/dashboard/leave'
      fullPath: '/dashboard/leave/'
      preLoaderRoute: typeof MainDashboardLeaveIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/leave/$id': {
      id: '/_main/dashboard/leave/$id'
      path: '/dashboard/leave/$id'
      fullPath: '/dashboard/leave/$id'
      preLoaderRoute: typeof MainDashboardLeaveIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/maintenance/': {
      id: '/_main/dashboard/maintenance/'
      path: '/dashboard/maintenance'
      fullPath: '/dashboard/maintenance/'
      preLoaderRoute: typeof MainDashboardMaintenanceIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/maintenance/$id': {
      id: '/_main/dashboard/maintenance/$id'
      path: '/dashboard/maintenance/$id'
      fullPath: '/dashboard/maintenance/$id'
      preLoaderRoute: typeof MainDashboardMaintenanceIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/maintenance/new': {
      id: '/_main/dashboard/maintenance/new'
      path: '/dashboard/maintenance/new'
      fullPath: '/dashboard/maintenance/new'
      preLoaderRoute: typeof MainDashboardMaintenanceNewRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/payroll-adjustments/': {
      id: '/_main/dashboard/payroll-adjustments/'
      path: '/dashboard/payroll-adjustments'
      fullPath: '/dashboard/payroll-adjustments/'
      preLoaderRoute: typeof MainDashboardPayrollAdjustmentsIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/payroll-runs/': {
      id: '/_main/dashboard/payroll-runs/'
      path: '/dashboard/payroll-runs'
      fullPath: '/dashboard/payroll-runs/'
      preLoaderRoute: typeof MainDashboardPayrollRunsIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/payroll-runs/$month': {
      id: '/_main/dashboard/payroll-runs/$month'
      path: '/dashboard/payroll-runs/$month'
      fullPath: '/dashboard/payroll-runs/$month'
      preLoaderRoute: typeof MainDashboardPayrollRunsMonthRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/payroll-runs/item-types': {
      id: '/_main/dashboard/payroll-runs/item-types'
      path: '/dashboard/payroll-runs/item-types'
      fullPath: '/dashboard/payroll-runs/item-types'
      preLoaderRoute: typeof MainDashboardPayrollRunsItemTypesRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/payroll-runs/rules': {
      id: '/_main/dashboard/payroll-runs/rules'
      path: '/dashboard/payroll-runs/rules'
      fullPath: '/dashboard/payroll-runs/rules'
      preLoaderRoute: typeof MainDashboardPayrollRunsRulesRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/policies/': {
      id: '/_main/dashboard/policies/'
      path: '/dashboard/policies'
      fullPath: '/dashboard/policies/'
      preLoaderRoute: typeof MainDashboardPoliciesIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/shifts/': {
      id: '/_main/dashboard/shifts/'
      path: '/dashboard/shifts'
      fullPath: '/dashboard/shifts/'
      preLoaderRoute: typeof MainDashboardShiftsIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/shifts/templates': {
      id: '/_main/dashboard/shifts/templates'
      path: '/dashboard/shifts/templates'
      fullPath: '/dashboard/shifts/templates'
      preLoaderRoute: typeof MainDashboardShiftsTemplatesRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/updates/': {
      id: '/_main/dashboard/updates/'
      path: '/dashboard/updates'
      fullPath: '/dashboard/updates/'
      preLoaderRoute: typeof MainDashboardUpdatesIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/updates/$id': {
      id: '/_main/dashboard/updates/$id'
      path: '/dashboard/updates/$id'
      fullPath: '/dashboard/updates/$id'
      preLoaderRoute: typeof MainDashboardUpdatesIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/updates/new': {
      id: '/_main/dashboard/updates/new'
      path: '/dashboard/updates/new'
      fullPath: '/dashboard/updates/new'
      preLoaderRoute: typeof MainDashboardUpdatesNewRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/zones/': {
      id: '/_main/dashboard/zones/'
      path: '/dashboard/zones'
      fullPath: '/dashboard/zones/'
      preLoaderRoute: typeof MainDashboardZonesIndexRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/zones/$id': {
      id: '/_main/dashboard/zones/$id'
      path: '/dashboard/zones/$id'
      fullPath: '/dashboard/zones/$id'
      preLoaderRoute: typeof MainDashboardZonesIdRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/zones/new': {
      id: '/_main/dashboard/zones/new'
      path: '/dashboard/zones/new'
      fullPath: '/dashboard/zones/new'
      preLoaderRoute: typeof MainDashboardZonesNewRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/companies/$id/edit': {
      id: '/_main/dashboard/companies/$id/edit'
      path: '/edit'
      fullPath: '/dashboard/companies/$id/edit'
      preLoaderRoute: typeof MainDashboardCompaniesIdEditRouteImport
      parentRoute: typeof MainDashboardCompaniesIdRoute
    }
    '/_main/dashboard/employees/$id/edit': {
      id: '/_main/dashboard/employees/$id/edit'
      path: '/edit'
      fullPath: '/dashboard/employees/$id/edit'
      preLoaderRoute: typeof MainDashboardEmployeesIdEditRouteImport
      parentRoute: typeof MainDashboardEmployeesIdRoute
    }
    '/_main/dashboard/incident-report-types/$id/edit': {
      id: '/_main/dashboard/incident-report-types/$id/edit'
      path: '/dashboard/incident-report-types/$id/edit'
      fullPath: '/dashboard/incident-report-types/$id/edit'
      preLoaderRoute: typeof MainDashboardIncidentReportTypesIdEditRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/leave-types/$id/edit': {
      id: '/_main/dashboard/leave-types/$id/edit'
      path: '/dashboard/leave-types/$id/edit'
      fullPath: '/dashboard/leave-types/$id/edit'
      preLoaderRoute: typeof MainDashboardLeaveTypesIdEditRouteImport
      parentRoute: typeof MainRoute
    }
    '/_main/dashboard/maintenance/$id/edit': {
      id: '/_main/dashboard/maintenance/$id/edit'
      path: '/edit'
      fullPath: '/dashboard/maintenance/$id/edit'
      preLoaderRoute: typeof MainDashboardMaintenanceIdEditRouteImport
      parentRoute: typeof MainDashboardMaintenanceIdRoute
    }
    '/_main/dashboard/updates/$id/edit': {
      id: '/_main/dashboard/updates/$id/edit'
      path: '/edit'
      fullPath: '/dashboard/updates/$id/edit'
      preLoaderRoute: typeof MainDashboardUpdatesIdEditRouteImport
      parentRoute: typeof MainDashboardUpdatesIdRoute
    }
    '/_main/dashboard/zones/$id/edit': {
      id: '/_main/dashboard/zones/$id/edit'
      path: '/edit'
      fullPath: '/dashboard/zones/$id/edit'
      preLoaderRoute: typeof MainDashboardZonesIdEditRouteImport
      parentRoute: typeof MainDashboardZonesIdRoute
    }
  }
}

interface AuthAnonymousRouteChildren {
  AuthAnonymousAcceptInviteRoute: typeof AuthAnonymousAcceptInviteRoute
  AuthAnonymousForgotPasswordRoute: typeof AuthAnonymousForgotPasswordRoute
  AuthAnonymousLoginRoute: typeof AuthAnonymousLoginRoute
  AuthAnonymousResetPasswordRoute: typeof AuthAnonymousResetPasswordRoute
  AuthAnonymousResubmitRoute: typeof AuthAnonymousResubmitRoute
}

const AuthAnonymousRouteChildren: AuthAnonymousRouteChildren = {
  AuthAnonymousAcceptInviteRoute: AuthAnonymousAcceptInviteRoute,
  AuthAnonymousForgotPasswordRoute: AuthAnonymousForgotPasswordRoute,
  AuthAnonymousLoginRoute: AuthAnonymousLoginRoute,
  AuthAnonymousResetPasswordRoute: AuthAnonymousResetPasswordRoute,
  AuthAnonymousResubmitRoute: AuthAnonymousResubmitRoute,
}

const AuthAnonymousRouteWithChildren = AuthAnonymousRoute._addFileChildren(
  AuthAnonymousRouteChildren,
)

interface AuthRouteChildren {
  AuthAnonymousRoute: typeof AuthAnonymousRouteWithChildren
  AuthMobileOnlyRoute: typeof AuthMobileOnlyRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAnonymousRoute: AuthAnonymousRouteWithChildren,
  AuthMobileOnlyRoute: AuthMobileOnlyRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface MainDashboardCompaniesIdRouteChildren {
  MainDashboardCompaniesIdEditRoute: typeof MainDashboardCompaniesIdEditRoute
}

const MainDashboardCompaniesIdRouteChildren: MainDashboardCompaniesIdRouteChildren =
  {
    MainDashboardCompaniesIdEditRoute: MainDashboardCompaniesIdEditRoute,
  }

const MainDashboardCompaniesIdRouteWithChildren =
  MainDashboardCompaniesIdRoute._addFileChildren(
    MainDashboardCompaniesIdRouteChildren,
  )

interface MainDashboardEmployeesIdRouteChildren {
  MainDashboardEmployeesIdEditRoute: typeof MainDashboardEmployeesIdEditRoute
}

const MainDashboardEmployeesIdRouteChildren: MainDashboardEmployeesIdRouteChildren =
  {
    MainDashboardEmployeesIdEditRoute: MainDashboardEmployeesIdEditRoute,
  }

const MainDashboardEmployeesIdRouteWithChildren =
  MainDashboardEmployeesIdRoute._addFileChildren(
    MainDashboardEmployeesIdRouteChildren,
  )

interface MainDashboardMaintenanceIdRouteChildren {
  MainDashboardMaintenanceIdEditRoute: typeof MainDashboardMaintenanceIdEditRoute
}

const MainDashboardMaintenanceIdRouteChildren: MainDashboardMaintenanceIdRouteChildren =
  {
    MainDashboardMaintenanceIdEditRoute: MainDashboardMaintenanceIdEditRoute,
  }

const MainDashboardMaintenanceIdRouteWithChildren =
  MainDashboardMaintenanceIdRoute._addFileChildren(
    MainDashboardMaintenanceIdRouteChildren,
  )

interface MainDashboardUpdatesIdRouteChildren {
  MainDashboardUpdatesIdEditRoute: typeof MainDashboardUpdatesIdEditRoute
}

const MainDashboardUpdatesIdRouteChildren: MainDashboardUpdatesIdRouteChildren =
  {
    MainDashboardUpdatesIdEditRoute: MainDashboardUpdatesIdEditRoute,
  }

const MainDashboardUpdatesIdRouteWithChildren =
  MainDashboardUpdatesIdRoute._addFileChildren(
    MainDashboardUpdatesIdRouteChildren,
  )

interface MainDashboardZonesIdRouteChildren {
  MainDashboardZonesIdEditRoute: typeof MainDashboardZonesIdEditRoute
}

const MainDashboardZonesIdRouteChildren: MainDashboardZonesIdRouteChildren = {
  MainDashboardZonesIdEditRoute: MainDashboardZonesIdEditRoute,
}

const MainDashboardZonesIdRouteWithChildren =
  MainDashboardZonesIdRoute._addFileChildren(MainDashboardZonesIdRouteChildren)

interface MainRouteChildren {
  MainDashboardAttendanceRoute: typeof MainDashboardAttendanceRoute
  MainDashboardAuditRoute: typeof MainDashboardAuditRoute
  MainDashboardNotificationsRoute: typeof MainDashboardNotificationsRoute
  MainDashboardReportsRoute: typeof MainDashboardReportsRoute
  MainDashboardSettingsRoute: typeof MainDashboardSettingsRoute
  MainDashboardTrackingRoute: typeof MainDashboardTrackingRoute
  MainDashboardWaitingListRoute: typeof MainDashboardWaitingListRoute
  MainDashboardIndexRoute: typeof MainDashboardIndexRoute
  MainDashboardBreaksIdRoute: typeof MainDashboardBreaksIdRoute
  MainDashboardCompaniesIdRoute: typeof MainDashboardCompaniesIdRouteWithChildren
  MainDashboardCompaniesNewRoute: typeof MainDashboardCompaniesNewRoute
  MainDashboardDeviceChangesIdRoute: typeof MainDashboardDeviceChangesIdRoute
  MainDashboardEmployeesIdRoute: typeof MainDashboardEmployeesIdRouteWithChildren
  MainDashboardEmployeesNewRoute: typeof MainDashboardEmployeesNewRoute
  MainDashboardIncidentReportTypesNewRoute: typeof MainDashboardIncidentReportTypesNewRoute
  MainDashboardIncidentsIdRoute: typeof MainDashboardIncidentsIdRoute
  MainDashboardLeaveTypesNewRoute: typeof MainDashboardLeaveTypesNewRoute
  MainDashboardLeaveIdRoute: typeof MainDashboardLeaveIdRoute
  MainDashboardMaintenanceIdRoute: typeof MainDashboardMaintenanceIdRouteWithChildren
  MainDashboardMaintenanceNewRoute: typeof MainDashboardMaintenanceNewRoute
  MainDashboardPayrollRunsMonthRoute: typeof MainDashboardPayrollRunsMonthRoute
  MainDashboardPayrollRunsItemTypesRoute: typeof MainDashboardPayrollRunsItemTypesRoute
  MainDashboardPayrollRunsRulesRoute: typeof MainDashboardPayrollRunsRulesRoute
  MainDashboardShiftsTemplatesRoute: typeof MainDashboardShiftsTemplatesRoute
  MainDashboardUpdatesIdRoute: typeof MainDashboardUpdatesIdRouteWithChildren
  MainDashboardUpdatesNewRoute: typeof MainDashboardUpdatesNewRoute
  MainDashboardZonesIdRoute: typeof MainDashboardZonesIdRouteWithChildren
  MainDashboardZonesNewRoute: typeof MainDashboardZonesNewRoute
  MainDashboardBreaksIndexRoute: typeof MainDashboardBreaksIndexRoute
  MainDashboardCompaniesIndexRoute: typeof MainDashboardCompaniesIndexRoute
  MainDashboardDeviceChangesIndexRoute: typeof MainDashboardDeviceChangesIndexRoute
  MainDashboardEmployeesIndexRoute: typeof MainDashboardEmployeesIndexRoute
  MainDashboardIncidentReportTypesIndexRoute: typeof MainDashboardIncidentReportTypesIndexRoute
  MainDashboardIncidentsIndexRoute: typeof MainDashboardIncidentsIndexRoute
  MainDashboardLeaveTypesIndexRoute: typeof MainDashboardLeaveTypesIndexRoute
  MainDashboardLeaveIndexRoute: typeof MainDashboardLeaveIndexRoute
  MainDashboardMaintenanceIndexRoute: typeof MainDashboardMaintenanceIndexRoute
  MainDashboardPayrollAdjustmentsIndexRoute: typeof MainDashboardPayrollAdjustmentsIndexRoute
  MainDashboardPayrollRunsIndexRoute: typeof MainDashboardPayrollRunsIndexRoute
  MainDashboardPoliciesIndexRoute: typeof MainDashboardPoliciesIndexRoute
  MainDashboardShiftsIndexRoute: typeof MainDashboardShiftsIndexRoute
  MainDashboardUpdatesIndexRoute: typeof MainDashboardUpdatesIndexRoute
  MainDashboardZonesIndexRoute: typeof MainDashboardZonesIndexRoute
  MainDashboardIncidentReportTypesIdEditRoute: typeof MainDashboardIncidentReportTypesIdEditRoute
  MainDashboardLeaveTypesIdEditRoute: typeof MainDashboardLeaveTypesIdEditRoute
}

const MainRouteChildren: MainRouteChildren = {
  MainDashboardAttendanceRoute: MainDashboardAttendanceRoute,
  MainDashboardAuditRoute: MainDashboardAuditRoute,
  MainDashboardNotificationsRoute: MainDashboardNotificationsRoute,
  MainDashboardReportsRoute: MainDashboardReportsRoute,
  MainDashboardSettingsRoute: MainDashboardSettingsRoute,
  MainDashboardTrackingRoute: MainDashboardTrackingRoute,
  MainDashboardWaitingListRoute: MainDashboardWaitingListRoute,
  MainDashboardIndexRoute: MainDashboardIndexRoute,
  MainDashboardBreaksIdRoute: MainDashboardBreaksIdRoute,
  MainDashboardCompaniesIdRoute: MainDashboardCompaniesIdRouteWithChildren,
  MainDashboardCompaniesNewRoute: MainDashboardCompaniesNewRoute,
  MainDashboardDeviceChangesIdRoute: MainDashboardDeviceChangesIdRoute,
  MainDashboardEmployeesIdRoute: MainDashboardEmployeesIdRouteWithChildren,
  MainDashboardEmployeesNewRoute: MainDashboardEmployeesNewRoute,
  MainDashboardIncidentReportTypesNewRoute:
    MainDashboardIncidentReportTypesNewRoute,
  MainDashboardIncidentsIdRoute: MainDashboardIncidentsIdRoute,
  MainDashboardLeaveTypesNewRoute: MainDashboardLeaveTypesNewRoute,
  MainDashboardLeaveIdRoute: MainDashboardLeaveIdRoute,
  MainDashboardMaintenanceIdRoute: MainDashboardMaintenanceIdRouteWithChildren,
  MainDashboardMaintenanceNewRoute: MainDashboardMaintenanceNewRoute,
  MainDashboardPayrollRunsMonthRoute: MainDashboardPayrollRunsMonthRoute,
  MainDashboardPayrollRunsItemTypesRoute:
    MainDashboardPayrollRunsItemTypesRoute,
  MainDashboardPayrollRunsRulesRoute: MainDashboardPayrollRunsRulesRoute,
  MainDashboardShiftsTemplatesRoute: MainDashboardShiftsTemplatesRoute,
  MainDashboardUpdatesIdRoute: MainDashboardUpdatesIdRouteWithChildren,
  MainDashboardUpdatesNewRoute: MainDashboardUpdatesNewRoute,
  MainDashboardZonesIdRoute: MainDashboardZonesIdRouteWithChildren,
  MainDashboardZonesNewRoute: MainDashboardZonesNewRoute,
  MainDashboardBreaksIndexRoute: MainDashboardBreaksIndexRoute,
  MainDashboardCompaniesIndexRoute: MainDashboardCompaniesIndexRoute,
  MainDashboardDeviceChangesIndexRoute: MainDashboardDeviceChangesIndexRoute,
  MainDashboardEmployeesIndexRoute: MainDashboardEmployeesIndexRoute,
  MainDashboardIncidentReportTypesIndexRoute:
    MainDashboardIncidentReportTypesIndexRoute,
  MainDashboardIncidentsIndexRoute: MainDashboardIncidentsIndexRoute,
  MainDashboardLeaveTypesIndexRoute: MainDashboardLeaveTypesIndexRoute,
  MainDashboardLeaveIndexRoute: MainDashboardLeaveIndexRoute,
  MainDashboardMaintenanceIndexRoute: MainDashboardMaintenanceIndexRoute,
  MainDashboardPayrollAdjustmentsIndexRoute:
    MainDashboardPayrollAdjustmentsIndexRoute,
  MainDashboardPayrollRunsIndexRoute: MainDashboardPayrollRunsIndexRoute,
  MainDashboardPoliciesIndexRoute: MainDashboardPoliciesIndexRoute,
  MainDashboardShiftsIndexRoute: MainDashboardShiftsIndexRoute,
  MainDashboardUpdatesIndexRoute: MainDashboardUpdatesIndexRoute,
  MainDashboardZonesIndexRoute: MainDashboardZonesIndexRoute,
  MainDashboardIncidentReportTypesIdEditRoute:
    MainDashboardIncidentReportTypesIdEditRoute,
  MainDashboardLeaveTypesIdEditRoute: MainDashboardLeaveTypesIdEditRoute,
}

const MainRouteWithChildren = MainRoute._addFileChildren(MainRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  MainRoute: MainRouteWithChildren,
  PolicySlugRoute: PolicySlugRoute,
  PolicyIndexRoute: PolicyIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
